<template>
  <div class="wrapper">
    <div class="row">
      <div class="col-md" style="min-width:200px;max-width:250px;">
        <div id="stencil"></div>
      </div>
      <div class="col-xl">
        <div style="display: flex">
          <div id="flowwrapper" style="flex: 1;border: 1px solid #eee;">
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <div id="flowminimap"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Graph,Shape,Addon } from '@antv/x6'

export default {
  name: 'FlowEditor',
  props: ["elements"],
  data() {
    return {
      graph: false,
    }
  },
  // floweditor methoden
  methods: {
    edgeMouseMove(e) {
      const { clientX, clientY } = e
      const p = this.graph.clientToLocal({x: clientX, y: clientY})
      if (this.newEdge) {
        this.newEdge.setTarget(p)
      }
    },
    edgeMouseUp(e) {
      document.removeEventListener('mousemove', this.edgeMouseMove)
      document.removeEventListener('mouseup', this.edgeMouseUp)

      const { clientX, clientY } = e
      const p = this.graph.clientToLocal({x: clientX, y: clientY})

      var nodes = this.graph.getNodesFromPoint(p.x,p.y);
      if (nodes && nodes.length > 0) {
        this.newEdge.setTarget(nodes[0]);
        this.newEdge.removeTools();
      } else {
        this.graph.removeEdge(this.newEdge);
      }
    },
    registerNode(name,template,add) {
      return Graph.registerNode(name,template,add);
    },
    createNode(node) {
      return this.graph.createNode(node);
    },
    fillElementGroup(elems,groupid) {
      this.stencil.load(elems, groupid);
    },
    addNode(node) {
      var ret = this.graph.addNode(node);
      this.$emit('add-node',node);
      return ret;
    },
    addEdge(edge) {
      return this.graph.addEdge(edge);
    },
    getNodes() {
      return this.graph.model.getNodes();
    },
    getEdges() {
      return this.graph.model.getEdges();
    }
  },
  // floweditor constructor
  mounted: function() {
    this.graph = new Graph({
      container: document.getElementById('flowwrapper'),
      autoResize: true,
      grid: true,
      history: true,
      keyboard: true,
      height: 500,
      scroller: {
        enabled: true,
        pannable: false,
        pageVisible: true,
        pageBreak: false,
      },
      mousewheel: {
        enabled: true,
        modifiers: ['ctrl', 'meta'],
      },
      selecting: {
        enabled: true,
        rubberband: true,
        showNodeSelectionBox: true,
      },
      minimap: {
        enabled: true,
        container: document.getElementById('flowminimap'),
      },
      connecting: {
        router: 'er',
        connector: {
          name: 'rounded',
          args: {
            radius: 8,
          },
        },
        allowBlank: false,
        createEdge() {
          return new Shape.Edge({
            label: 'unset',
            attrs: {
              line: {
                stroke: '#A2B1C3',
                strokeWidth: 2,
                targetMarker: {
                  name: 'block',
                  width: 12,
                  height: 8,
                },
              },
            },
            tools: [
              {
                name: 'vertices',
                args: {
                  attrs: { fill: '#666' },
                },
              }
            ],
            zIndex: 0,
          })
        },
        validateConnection({ targetMagnet }) {
          return !!targetMagnet
        },
      }
    });

    this.stencil = new Addon.Stencil({
      title: 'Elemente',
      target: this.graph,
      stencilGraphWidth: 200,
      stencilGraphHeight: 280,
      collapsable: true,
      groups: this.elements,
      layoutOptions: {
        columns: 1,
        columnWidth: 120,
        rowHeight: 65,
      },
    });

    document.getElementById('stencil').appendChild(this.stencil.container)

    var self = this;

    this.graph.on('node:mouseenter', ({node}) => {
      node.addTools([
        {
          name: 'button-remove',
          args: {
            x: '90%', y:'25%',r: 14,
          },
        },
        {
          name: 'button',
          args: {
            markup: [
              {
                tagName: 'circle',
                selector: 'button',
                attrs: {
                  r: 10,
                  stroke: '#262626',
                  strokeWidth: 2,
                  fill: 'white',
                  cursor: 'pointer',
                },
              },
              {
                tagName: 'line',
                attrs: {
                  x1: -5,
                  x2: 5,
                  y1: 0,
                  y2: 0,
                  stroke: '#262626',
                  strokeWidth: 2
                }
              }
            ],
            x: '10%',
            y: '25%',
            onClick({cell,e}) {
              self.source = cell;
              const { clientX, clientY } = e;
              const p = self.graph.clientToLocal({x: clientX, y: clientY})
              self.newEdge = self.graph.addEdge({
                source: cell,
                target: p,
                vertices: []
              });
              document.addEventListener('mouseup', self.edgeMouseUp)
              document.addEventListener('mousemove', self.edgeMouseMove)
            }
          }
        }
      ])
    })

    this.graph.on('node:mouseleave', ({node}) => {
      node.removeTools();
    })

    this.graph.on('edge:mouseenter', ({ edge }) => {
      edge.addTools([
        'source-arrowhead',
        'target-arrowhead',
        'vertices',
        {
          name: 'button',
          args: {
            distance: -55,
            onClick: function(view) {
              console.log('click on edge',view.cell);
              view.view.graph.select(view.cell);
            },
            markup: [
              {
                tagName: 'circle',
                selector: 'button',
                attrs: {
                  r: 10,
                  stroke: '#fe854f',
                  fill: 'white',
                  cursor: 'pointer',
                }
              },
              {
                tagName: 'text',
                textContent: 'Edit',
                selector: 'icon',
                attrs: {
                  cursor: 'pointer',
                  fontSize: 9,
                  textAnchor: 'middle',
                  y: '0.3em'
                }
              }
            ]
          }
        },
        {
          name: 'button-remove',
          args: {
            distance: -30,
          },
        },
      ])
    })

    this.graph.on('edge:mouseleave', ({ edge }) => {
      edge.removeTools()
    })

    this.graph.on('edge:selected', ({ edge }) => {
      self.$emit('selectEdge',{edge: edge})
    })

    this.graph.on('edge:unselected',({edge}) =>  {
      self.$emit('unselectEdge',{edge: edge})
    })

    this.graph.on('node:selected', ({ node }) => {
      node.removeTools();
      console.log(node);
      self.$emit('selectNode',{node: node})
    })

    this.graph.on('node:unselected', ({ node }) => {
      this.$emit('unselectedNode',{node:node});
    })

    this.graph.on('node:added', ({ node }) => {
      console.log('added: ',node);
    })

    this.graph.on('edge:added', ({ edge }) => {
      console.log('add edge:',edge);
      this.$emit('add-edge',{ edge });
    })


  }
}
</script>

<style>
@import '../../../node_modules/@antv/x6/dist/x6.css';
</style>
